/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    triggerSignIn as triggerSignInBase,
    triggerSignUp as triggerSignUpBase,
    type ExternalTriggerParams,
    SIGNING_FLOW_TYPE_MAP,
} from '@fiverr-private/identification_core';
import { useBusinessSignInSteps } from './hooks/useBusinessSignInSteps';

/**
 * Triggers the identification modal with sign-up intention.
 *
 * @param params - Optional configuration parameters for the modal and BI tracking
 * @returns Promise that resolves when the modal is displayed
 */
const triggerSignUp = (params?: ExternalTriggerParams) => triggerSignUpBase(params);

/**
 * Triggers the identification modal with sign-in intention.
 *
 * @param params - Optional configuration parameters for the modal and BI tracking
 * @returns Promise that resolves when the modal is displayed
 */
const triggerSignIn = (params?: ExternalTriggerParams) => triggerSignInBase(params);

export { triggerSignIn, triggerSignUp, type ExternalTriggerParams, useBusinessSignInSteps, SIGNING_FLOW_TYPE_MAP };
